import React from "react";
import { Row, Col, ListGroup } from "react-bootstrap";
import { useMemo } from "react";
import {
  DetalleTransporte,
  SalidaTransporte,
} from "../../../services/transporteServicios";
import { ModificacionesDetalle, ordenarDetalles } from "./Modificaciones";
import SalidaItem from "./SalidaItem";
import { useAutoAnimate } from "@formkit/auto-animate/react";

function Salidas({
  salidas,
  onDetalleClick,
  onChequearSalida,
  modificacionesSalidas,
  onSubirOrden,
  onBajarOrden,
}: {
  salidas: SalidaTransporte[];
  onDetalleClick: (detalle: DetalleTransporte) => void;
  onChequearSalida: (entrada: SalidaTransporte, transportado: boolean) => void;
  onSubirOrden: (entrada: SalidaTransporte, anterior: SalidaTransporte) => void;
  onBajarOrden: (
    entrada: SalidaTransporte,
    siguiente: SalidaTransporte
  ) => void;
  modificacionesSalidas: Map<string, ModificacionesDetalle> | undefined;
}) {
  const items = useMemo(() => {
    return ordenarDetalles(salidas, modificacionesSalidas);
  }, [salidas, modificacionesSalidas]);

  const [animationParent] = useAutoAnimate<HTMLOListElement>();

  return (
    <>
      <Row>
        <Col className="col-12">
          <ListGroup as="ol" numbered ref={animationParent}>
            {items.map((salida, i) => (
              <SalidaItem
                salida={salida}
                key={salida.id}
                onDetalleClick={onDetalleClick}
                onChequearSalida={onChequearSalida}
                modificacionesSalida={modificacionesSalidas?.get(salida.id)}
                onSubirOrden={onSubirOrden}
                onBajarOrden={onBajarOrden}
                esPrimero={i === 0}
                esUltimo={i === items.length - 1}
                anterior={i === 0 ? undefined : items[i - 1]}
                siguiente={i === items.length - 1 ? undefined : items[i + 1]}
              />
            ))}
          </ListGroup>
        </Col>
      </Row>
    </>
  );
}

export default Salidas;
